(() => {
  if (window.CourumExperienceBound) return;
  window.CourumExperienceBound = true;
  let pending = false;

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-courum-add-experience]');
    if (!button || button.disabled || pending) return;
    event.preventDefault();
    event.stopPropagation();
    const variantId = button.dataset.variantId;
    if (!/^\d+$/.test(variantId || '')) return;
    pending = true;
    const label = button.textContent;
    const status = button.closest('.CourumExperiencePurchase')?.querySelector('.CourumExperienceStatus');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.busy;
    if (status) status.textContent = '';
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    try {
      const root = window.Shopify?.routes?.root || '/';
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || button.dataset.error);
      if (status) status.textContent = button.dataset.success;
      if (document.querySelector('#sidebar-cart')) {
        document.dispatchEvent(new CustomEvent('product:added', {bubbles: true, detail: {quantity: 1, variant: result}}));
      } else {
        window.location.assign(root + 'cart');
      }
    } catch (error) {
      if (status) status.textContent = error instanceof TypeError ? button.dataset.error : error.message || button.dataset.error;
    } finally {
      pending = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = label;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
  });
})();
